import update from 'immutability-helper';
import { combineReducers } from 'redux';
import Enums from 'utils/EnumsManager';
import setup from 'views/ReportFilters/flow/reducer';
import preview from 'views/ReportPreview/flow/reducer';
import { MOVE_TO_ZONE, RESET_ON_DROP, SET_ACTIONS, SWAP_CARDS, SET_MODALE_SORTER_VALUE, RESET_MODALE_SORTER_VALUE, SET_MODAL_SELECTED_SOTER_ASINITIAL, RESET_MODAL_SORTER, SET_MODAL_SOTERS } from 'views/ReportTableSetup/flow/actionTypes';
import { toModel, sortSelectedCols } from '../utils/index';
import { SET_AVAILABLE_COLUMNS, SET_ZONES, RESET_SELECTEDCOLS } from './actionTypes';

const { SortOrders, DROPZONES, REPORTS } = Enums;
const { SIDER, GROUPS, OTHERS, AGGREGATES } = DROPZONES;
const { GROUPSORTER, ORTHERSSORRTER } = REPORTS.SORTER;
const { ascend, descend } = SortOrders;

const initialSider = {
  availableColumns: [],
  selectedCols: [],
};

const sider = (state = initialSider, action) => {
  switch (action.type) {
    case SET_AVAILABLE_COLUMNS:
      return {
        ...state,
        availableColumns: toModel(action.payload.availableColumns),
      };

    case SET_ZONES:
      const { group_by, selectors, aggregations } = action.payload.zonesData;
      const selectedCols = [];
      const loadedColumns = state.availableColumns.map((col) => {
        const groupElem = _.find(group_by, { field_name: col.name });
        if (groupElem) {
          col.belongTo = GROUPS;
          col.disabled = true;
          col.actions = groupElem.type;
          selectedCols.push(col);
        }
        const othersElem = _.indexOf(selectors, col.name) > -1;
        if (othersElem) {
          col.belongTo = OTHERS;
          col.disabled = true;
          selectedCols.push(col);
        }
        const aggregateElem = _.find(aggregations, { field_name: col.name });
        if (aggregateElem) {
          col.belongTo = AGGREGATES;
          col.disabled = true;
          col.actions = aggregateElem.functions;
          selectedCols.push(col);
        }
        return col;
      });
      return {
        ...state,
        availableColumns: loadedColumns,
        selectedCols: sortSelectedCols(selectedCols, group_by, selectors, aggregations),
      };

    case MOVE_TO_ZONE:
      const { targetZone, columnId } = action.payload;
      const changeSelected = [...state.selectedCols];
      const checkColumnIsSelected = changeSelected.find(item => item && item.id === columnId);
      if (checkColumnIsSelected && checkColumnIsSelected.fieldDeleted) {
        _.remove(changeSelected, { id: columnId });
      }
      const availableColumns = state.availableColumns.map((col) => {
        col.onDrop = false;
        if (col.id === columnId) {
          // Clear column actions if target zone changed
          if (targetZone !== col.belongTo) {
            col.actions = null;
            // Show modal of group action on drop to Group or Aggregate zone.
            col.onDrop = true;
          }
          col.belongTo = targetZone;
          col.disabled = targetZone !== SIDER;
          if (col.belongTo === GROUPS || col.belongTo === OTHERS || col.belongTo === AGGREGATES) {
            if (!checkColumnIsSelected) {
              changeSelected.push(col);
            }
          } else {
            _.remove(changeSelected, { id: columnId });
          }
        }
        return col;
      });
      return {
        ...state,
        availableColumns,
        selectedCols: changeSelected,
      };

    case SWAP_CARDS:
      const { dragId, dropId, isDropBeforeTarget } = action.payload;
      const dragItem = state.availableColumns.find(col => col.id === dragId);
      const dragIndex = _.findIndex(state.selectedCols, { id: dragId });
      const dropIndex = _.findIndex(state.selectedCols, { id: dropId });
      const exitItem = state.selectedCols.find(col => col && col.id === dragId);
      if (_.isEmpty(exitItem)) {
        return state;
      }
      return update(state, {
        selectedCols: {
          $splice: [[dragIndex, 1], [dropIndex, 0, dragItem]],
        },
      });

    case RESET_ON_DROP:
      const dataAfterResetOnDrop = state.availableColumns.map((col) => {
        col.onDrop = false;
        return col;
      });
      return {
        ...state,
        availableColumns: dataAfterResetOnDrop,
      };

    case SET_ACTIONS:
      const dataAfterUpdate = state.availableColumns.map((col) => {
        if (col.id === action.payload.columnId) {
          col.actions = action.payload.actions;
        }
        return col;
      });
      return {
        ...state,
        availableColumns: dataAfterUpdate,
      };

    case RESET_SELECTEDCOLS:
      return {
        ...state,
        selectedCols: initialSider.selectedCols,
      };

    default:
      return state;
  }
};

const initialSorter = {
  [GROUPSORTER]: {
    selectedValue: {
      name: { value: '' },
      action: { value: '' },
      direction: ascend,
    },
    initialValue: {
      name: { value: '' },
      action: { value: '' },
      direction: ascend,
    }
  },
  [ORTHERSSORRTER]: {
    selectedValue: {
      name: { value: '' },
      action: { value: '' },
      direction: ascend,
    },
    initialValue: {
      name: { value: '' },
      action: { value: '' },
      direction: ascend,
    }
  }
};

const sorter = (state = initialSorter, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_MODAL_SOTERS:
      const { groupSorter, otherSorter } = payload;
      /**
       * @param {Array} groupSorter sorter1, includes the fields of group zone and aggreage zone
       * @param {Array} otherSorter sorter2, includes all fields of all zones.
       * Cause each sorter have only one row for now, therefore we select the first element from each sorter.
       * TODO: change all sorters render by array, the reducer, action, and view need to be fixed.
       */
      return {
        ...state,
        [GROUPSORTER]: {
          ...state[GROUPSORTER],
          selectedValue: {
            name: {
              value: groupSorter[0].field_name
            },
            action: {
              value: groupSorter[0].suffix_key
            },
            direction: groupSorter[0].direction
          },
          initialValue: {
            name: {
              value: groupSorter[0].field_name
            },
            action: {
              value: groupSorter[0].suffix_key
            },
            direction: groupSorter[0].direction
          }
        },
        [ORTHERSSORRTER]: {
          ...state[ORTHERSSORRTER],
          selectedValue: {
            name: {
              value: otherSorter[0].field_name
            },
            action: {
              value: otherSorter[0].suffix_key
            },
            direction: otherSorter[0].direction
          },
          initialValue: {
            name: {
              value: otherSorter[0].field_name
            },
            action: {
              value: otherSorter[0].suffix_key
            },
            direction: otherSorter[0].direction
          }
        },
      };

    case SET_MODALE_SORTER_VALUE:
      const { fieldsKey, actionKey, value } = payload;
      return {
        ...state,
        [fieldsKey]: {
          ...state[fieldsKey],
          selectedValue: {
            ...state[fieldsKey].selectedValue,
            [actionKey]: value,
          }
        }
      };

    case RESET_MODALE_SORTER_VALUE:
      return {
        ...state,
        [GROUPSORTER]: {
          ...state[GROUPSORTER],
          selectedValue: state[GROUPSORTER].initialValue,
        },
        [ORTHERSSORRTER]: {
          ...state[ORTHERSSORRTER],
          selectedValue: state[ORTHERSSORRTER].initialValue,
        }
      };

    case RESET_MODAL_SORTER:
      return initialSorter;

    case SET_MODAL_SELECTED_SOTER_ASINITIAL:
      return {
        ...state,
        [GROUPSORTER]: {
          ...state[GROUPSORTER],
          initialValue: state[GROUPSORTER].selectedValue,
        },
        [ORTHERSSORRTER]: {
          ...state[ORTHERSSORRTER],
          initialValue: state[ORTHERSSORRTER].selectedValue,
        }
      };

    default:
      return state;
  }
};

export default combineReducers({
  setup,
  sider,
  preview,
  sorter
});



// WEBPACK FOOTER //
// ./src/views/ReportSetup/flow/reducer.js